import { render, staticRenderFns } from "./TorqStts.vue?vue&type=template&id=4575fd6e&"
import script from "./TorqStts.vue?vue&type=script&lang=js&"
export * from "./TorqStts.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports